import gql from 'graphql-tag';

export default gql`
mutation competencyDocumentCreate(
    $title: String,
    $workspaceId: UUID!
  ) {
    competencyDocumentCreate (input: {
      title: $title,
      workspaceId: $workspaceId
    }) {
        document {
            documentId
            title
            workspaceId
            createdAt
            lastChangedAt
      }
    }
  }
`;